export default "/assets/4a9bbc048fbbe36d.svg"